import { useEffect } from 'react';
import {
  gsap,
  setupGsap,
  prefersReducedMotion,
} from '../motion/gsapSetup';

/**
 * Fade/slide elements into view on scroll.
 * @param {React.RefObject} containerRef
 * @param {string} selector
 * @param {{ y?: number, stagger?: number, start?: string, once?: boolean }} options
 */
const useReveal = (containerRef, selector = '[data-reveal]', options = {}) => {
  const { y = 48, stagger = 0.1, start = 'top 85%', once = true } = options;

  useEffect(() => {
    setupGsap();
    const root = containerRef?.current;
    if (!root) return undefined;

    const targets = root.querySelectorAll(selector);
    if (!targets.length) return undefined;

    if (prefersReducedMotion()) {
      gsap.set(targets, { clearProps: 'all', opacity: 1, y: 0 });
      return undefined;
    }

    const ctx = gsap.context(() => {
      gsap.fromTo(
        targets,
        { opacity: 0, y },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: root,
            start,
            toggleActions: once ? 'play none none none' : 'play none none reverse',
          },
        }
      );
    }, root);

    return () => ctx.revert();
  }, [containerRef, selector, y, stagger, start, once]);
};

export default useReveal;
